import "./landpage.css"
import { Navbar } from "./sections/navbar"
import { Hero } from "./sections/hero"
import { TrustBar } from "./sections/trust-bar"
import { HowItWorks } from "./sections/how-it-works"
import { Features } from "./sections/features"
import { Demo } from "./sections/demo"
import { ForWhom } from "./sections/for-whom"
import { Pricing } from "./sections/pricing"
import { FinalCTA } from "./sections/final-cta"
import { Footer } from "./sections/footer"

export const LandPage = () => {
  return (
    <div className="landpage-root min-h-screen bg-background text-foreground overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <HowItWorks />
        <Features />
        <Demo />
        <ForWhom />
        <Pricing />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  )
}
